import { DefaultRootState, useSelector } from 'react-redux';
import { useFilter } from './filter';
import { DependencyList } from 'react';

/**
 * A hook that combines useSelector and useFilter to filter items from Redux state
 * 
 * @param selector - Function that selects an array from Redux state
 * @param predicate - Filter function that returns true for items to keep
 * @param deps - Optional dependency array for memoization
 * @returns Filtered array of items that match the predicate
 */
export function useFilterSelector<TState = DefaultRootState, TSelected = unknown>(
    selector: (state: TState) => TSelected[],
    predicate: (item: TSelected) => boolean,
    deps?: DependencyList
) {
    return useFilter(useSelector(selector), predicate, deps);
}
